import DateUtils from "../../../../shared/utils/DateUtils";
import CnpjUtils from "../../../../shared/utils/CnpjUtils";

export const filtersConfig = () => [
	{
		name: "startDate",
		label: "Data de Início *",
		type: "date",
		placeholder: "26/05/2026",
		defaultValue: DateUtils.getDateMonthsAgo(2),
		columns: 4
	},
	{
		name: "endDate",
		label: "Data Final *",
		type: "date",
		placeholder: "26/05/2026",
		defaultValue: new Date(),
		columns: 4
	},
	{
		name: "status",
		label: "Status",
		type: "select",
		options: [
			{ label: "Todos", value: "all" },
			{ label: "Pendente de Envio", value: "pendente" },
			{ label: "Enviado", value: "enviado" }
		],
		defaultValue: "all",
		columns: 4
	},
	{
		name: "clientDocument",
		label: "CNPJ do Cliente",
		type: "text",
		placeholder: "00.000.000/0000-00",
		defaultValue: "",
		mask: CnpjUtils.getAlphanumericCnpjMask(),
		guide: false,
		onChange: value => value.toUpperCase(),
		columns: 4
	},
	{
		name: "clientName",
		label: "Nome do Cliente",
		type: "text",
		placeholder: "Razão Social ou Nome",
		defaultValue: "",
		columns: 8
	}
];